import React from 'react';
import { IChartCardRightProps } from '.';
import { TrafficLightStackedChart } from '..';

const TrafficLightRight: React.FC<IChartCardRightProps> = ({ helper }) => (
  <>
    <div className="flex justify-between mb3">
      <p className="f7 fw5 mt0 mb1">most frequent entry: {helper.mostFrequentTrafficLight()}</p>
      <p className="f7 fw5 mt0 mb1">{helper.measurementCount} entries</p>
    </div>
    <TrafficLightStackedChart helper={helper} short={true} />
  </>
);

export default TrafficLightRight;
